import { Tabs } from '@mui/material';
import { TabsProps } from '@mui/material/Tabs/Tabs';

import { useContentSwitcherStyles } from './useContentSwitcherStyles';

export type ContentSwitcherSizeType = 'large' | 'medium' | 'small' | 'tiny';

interface IContentSwitcherProps extends TabsProps {
  size?: ContentSwitcherSizeType;
}

export function ContentSwitcher({
  size = 'medium',
  ...tabsProps
}: IContentSwitcherProps) {
  const { classes, cx } = useContentSwitcherStyles();

  return (
    <Tabs
      className={cx(
        tabsProps?.classes?.root,
        classes.root,
        size === 'tiny' && classes.sizeTiny,
        size === 'small' && classes.sizeSmall,
        size === 'medium' && classes.sizeMedium,
        size === 'large' && classes.sizeLarge,
      )}
      {...tabsProps}
    >
      {tabsProps.children}
    </Tabs>
  );
}
